import { ERROR, LOADING, READY, useVisualState } from '../../../hooks/useVisualState'
import { Link, withRouter } from 'react-router-dom'
import React, { useEffect } from 'react'
import { get } from '../../../helpers/request'
import t from '../../../helpers/i18n'
import Button from '../../../components/Button/Button'
import "./SitesView.scss"

const SitesView = ({ history, match }) => {
  const [[sitesState, sites], setSites] = useVisualState()

  useEffect(() => {
    setSites(LOADING)
    get('/soccer/sites')
      .then((response) => {
        setSites(READY, response)
      })
      .catch((error) => {
        setSites(ERROR, error)
      })
  }, [setSites])

  return (
    <div className="main-content competition-view-page">
      <div className="-page-header">
        <div className="-title">
          <div className="-left label-display-medium-semibold">{t('titles.Sites')}</div>
        </div>
        <div className='-right'>
          <Button
            label={t('buttons.New_site')}
            type='light'
            size='field-sized'
            color='green'
            onClick={() => history.push('/soccer/sites/new')}
          />
        </div>
      </div>
      <div className="-content">
        {sitesState === READY &&
          sites.map((site) => (
            <div key={site.site_id} className='sites-card'>
              <Link to={'/soccer/sites/' + site.site_id}>{site.name}</Link>
            </div>
          ))
        }
        {sitesState === ERROR && <div>Error: {sites.code}</div>}
      </div>
    </div>
  )
}

export default withRouter(SitesView)
